import { Injectable } from '@angular/core';
import {
  ProductAuxiliaryFieldDataApiService,
  ListAuxiliaryDataRequestInterface,
  UpsertAuxiliaryDataRequestInterface,
  ListAuxiliaryDataResponse,
} from '@vendasta/marketplace-apps';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAuxiliaryDataSchemaService } from './_abstract.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService implements AbstractAuxiliaryDataSchemaService {
  constructor(private readonly service: ProductAuxiliaryFieldDataApiService) {}

  listData(request: ListAuxiliaryDataRequestInterface): Observable<ListAuxiliaryDataResponse> {
    return this.service.listAuxiliaryData(request);
  }

  upsertData(request: UpsertAuxiliaryDataRequestInterface): Observable<null> {
    return this.service.upsertAuxiliaryData(request).pipe(map(() => null));
  }
}
